/* eslint-disable no-dupe-keys */
import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: '',
    name: 'ID',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },  
  {
    label: '',
    name: 'planstage',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },    
  {
    label: '',
    name: 'status',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },    
  {
    label: 'Year',
    name: 'year',
    layout: 'fullWidth',
    maxLength: 4,
    validators: [
      {
        check: 'required',
        check: 'requiredNumber',
        error: 'Please enter current financial year',
      },
    ],
  },
  {
    label: 'Partner plan form link',
    name: 'formurl',
    layout: 'fullWidth',
    maxLength: 500,
    validators: [
      {
        check: 'required',
        error: 'Please enter link to Partner plan form',
      },
    ],
  },
  {
    label: 'Partner hub guidance link',
    name: 'guidanceurl',
    layout: 'fullWidth',
    maxLength: 500,
    validators: [
      {
        check: 'required',
        error: 'Please enter link to Partner hub guidance page',
      },
    ],
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/PartnerPlanAdminOverviewForm.js